<template>
  <div id="admin-container" class="wrapper">
    <div class="inner-wrap">
      <h2>Mailchimp Campaigns</h2>
      <div class="list-wrap">
        <div class="pure-form pure-form-stacked">
          <h4>Create campaign</h4>
          <label>Grape List</label>
          <select name="list_select" id="list_select" v-on:change="listChange()">
            <option v-for="list in lists" :value="list.id">{{list.name}}</option>
          </select>
          <label>Mailchimp List</label>
          <select name="mailchimplist_select" id="mailchimplist_select">
            <option v-for="mailchimpList in mailchimpLists" :value="mailchimpList.id">{{mailchimpList.name}}</option>
          </select>
          <label>Start schedule time</label>
          <datetime type="datetime" :minute-step="15" class="theme-grapevine" v-model="datetime"></datetime>
          <div class="pure-button" v-on:click="createMailchimpCampaign">Create New Campaign</div>
        </div>
        <div class="campaigns-table-wrap">
          <h4>Campaigns</h4>
          <table class="campaigns-table pure-table">
            <thead>
              <tr>
                <th>grapeList</th>
                <th>mailchimpList</th>
                <th>mailchimpCampaignID</th>
                <th>mailchimpCampaignSubject</th>
                <th>Schedule Time</th>
                <th>Status</th>
                <th>Date Created</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="localCampaign in localCampaigns" :data-id="localCampaign.id" :data-status="localCampaign.mailchimpCampaignStatus">
                <td>{{localCampaign.grapeListName}}</td>
                <td>{{localCampaign.mailchimpListName}}</td>
                <td>{{localCampaign.mailchimpCampaignID}}</td>
                <td>{{localCampaign.mailchimpCampaignSubject}}</td>
                <td v-if="localCampaign.mailchimpCampaignSendTime">{{localCampaign.mailchimpCampaignSendTime}}</td>
                <td v-else>--</td>
                <td>{{localCampaign.mailchimpCampaignStatus}}</td>
                <td>{{localCampaign.createdTimestamp}}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  /* global $, algoliasearch */
  import firebase from 'firebase'
  import db from '../firebaseInit'
  import Request from 'superagent'
  import { Datetime } from 'vue-datetime';
  import 'vue-datetime/dist/vue-datetime.css'

  export default {
    data: function () {
      return {
        root: 'grapes-table',
        currentUserID: null,
        currentList: null,
        userLoggedIn: false,
        userIsAdmin: this.$globals.userRole == 'admin',
        lists: [],
        listGrapeIDs: [],
        mailchimpLists: [],
        localCampaigns: [],
        datetime: null,
        grapeIDs: [],
        isAddingCampaign: false,
        segment1aday: '53021',
        segment3aday: '53025',
        segment7aweek: '53029',
        mailchimpListID: null,
        mailchimpListName: null,
        grapeListID: null,
        grapeListName: null,
        datetime: null
      }
    },
    name: 'mailchimpAdmin',
    components: {
      datetime: Datetime
    },
    created () {
      let vm = this
      firebase.auth().onAuthStateChanged(function(user) {
        if (user) {
          vm.userLoggedIn = true
        } else {
          vm.userLoggedIn = false
        }
      })
      vm.$globals.isAdmin = true
      vm.showLoading()
      firebase.auth().onAuthStateChanged(function (user) {
        if (user) {
          vm.currentUserID = user.uid
          vm.getLists()
          vm.getMailchimpLists()
          // vm.getLocalCampaigns()
        }
      })

      $(document).on('click', '.remove-grape', function () {
        vm.removeGrapeFromList($(this).data('id'))
        return false
      })
    },
    methods: {
      showLoading () {
        $('body').addClass('pace-running')
        $('.pace').addClass('pace-active')
      },
      hideLoading () {
        $('body').removeClass('pace-running')
        $('.pace').removeClass('pace-active')
      },
      addUTCDays: function (date, days) {
        var d = new Date(date)
        var d2 = d.setDate(d.getDate() + days)
        var returnDate = new Date(d2).toISOString()
        return returnDate
      },
      getMailchimpLists () {
        let vm = this
        console.log('doing request')
        const req = Request
        .get('https://us-central1-grapevine-dc853.cloudfunctions.net/MailchimpListLists')
        .then(function(res) {
          var obj = JSON.parse(res.body.text)
          console.log(res)
          console.log(obj)
          for (let i = 0; i < obj.lists.length; i++) {
            let data = obj.lists[i]
            vm.mailchimpLists.push({
              id: data.id,
              name: data.name
            }) 
          }
          setTimeout(function () {
            vm.hideLoading()
          }, 1000)
        })
      },
      createMailchimpCampaign () {
        console.log('createMailchimpCampaign')
        let vm = this
        let segment1count = 7
        let segment2count = 7
        let segment3count = 1
        var seg1ScheduleTime = vm.datetime
        var seg2ScheduleTime = vm.datetime
        var seg3ScheduleTime = vm.addUTCDays(vm.datetime, 6)
        var grapeIDs = []
        vm.grapeListID = $('#list_select').val()
        vm.grapeListName = $('#list_select option:selected').text()
        vm.mailchimpListID = $('#mailchimplist_select').val()
        vm.mailchimpListName = $('#mailchimplist_select option:selected').text()

        vm.showLoading()

        // update grape mailchimp count
        const req = Request
        .post('https://us-central1-grapevine-dc853.cloudfunctions.net/grapesIncreaseMailchimpCampaignCount')
        .query({ grapeIDs: vm.listGrapeIDs })
        .then(function() {
          console.log('updated grape mailchimp count')
        })

        // 1 a day
        for (var s1 = 0; s1 < segment1count; s1++) {
          grapeIDs = []
          var grapeID = vm.listGrapeIDs[s1]
          grapeIDs.push(grapeID)
          console.log('creating 1 a day campaign with start time: ' + seg1ScheduleTime)
          console.log(grapeIDs)
          vm.createSegment1MailchimpCampaign(grapeIDs, s1+1, seg1ScheduleTime)
          seg1ScheduleTime = vm.addUTCDays(seg1ScheduleTime, 1)
        }

        // 3 a day
        for (var s2 = 0; s2 < segment2count; s2++) {
          grapeIDs = vm.listGrapeIDs.slice((s2 * 3), ((s2 + 1) * 3))
          console.log('creating 3 a day campaign with start time: ' + seg2ScheduleTime)
          console.log(grapeIDs)
          vm.createSegment2MailchimpCampaign(grapeIDs, s2+1, seg2ScheduleTime)
          seg2ScheduleTime = vm.addUTCDays(seg2ScheduleTime, 1)
        }

        // 7 a week
        grapeIDs = vm.listGrapeIDs.slice(0,7)
        console.log('creating 7 grape weekly campaign with start time: ' + seg3ScheduleTime)
        console.log(grapeIDs)
        vm.createSegment3MailchimpCampaign(grapeIDs, seg3ScheduleTime)
      },
      createSegment1MailchimpCampaign: function (grapeIDs, n, datetime) {
        let vm = this
        const req = Request        
        .post('https://us-central1-grapevine-dc853.cloudfunctions.net/MailchimpCreateCampaign')
        .query({ list_id: vm.mailchimpListID })
        .query({ title: vm.mailchimpListName + ': ' + vm.grapeListName + ': 1 a day ' + n + '/7' })
        .query({ subject: 'Your daily email from Grapevine' })
        .query({ segment_id: vm.segment1aday })
        .then(function(res) {
            var data = JSON.parse(res.body.text)
            console.log(data)
            if (data.id) {
              let campaignData = {
                grapeListID : vm.grapeListID,
                grapeListName : vm.grapeListName,
                mailchimpListID : vm.mailchimpListID,
                mailchimpListName : vm.mailchimpListName,
                mailchimpCampaignID : data.id,
                mailchimpCampaignSubject : data.settings.title,
                mailchimpCampaignStatus : data.status,
                creationScheduledTime: datetime 
              }
              vm.setCampaignContent(data.id, grapeIDs, datetime)
              vm.createLocalCampaign(campaignData)
            }
         });
      },
      createSegment2MailchimpCampaign: function (grapeIDs, n, datetime) {
        let vm = this
        const req = Request        
        .post('https://us-central1-grapevine-dc853.cloudfunctions.net/MailchimpCreateCampaign')
        .query({ list_id: vm.mailchimpListID })
        .query({ title: vm.mailchimpListName + ': ' + vm.grapeListName + ': 3 a day ' + n + '/7' })
        .query({ subject: 'Your daily email from Grapevine' })
        .query({ segment_id: vm.segment3aday })
        .then(function(res) {
            var data = JSON.parse(res.body.text)
            console.log(data)
            if (data.id) {
              let campaignData = {
                grapeListID : vm.grapeListID,
                grapeListName : vm.grapeListName,
                mailchimpListID : vm.mailchimpListID,
                mailchimpListName : vm.mailchimpListName,
                mailchimpCampaignID : data.id,
                mailchimpCampaignSubject : data.settings.title,
                mailchimpCampaignStatus : data.status,
                creationScheduledTime: datetime 
              }
              vm.setCampaignContent(data.id, grapeIDs, datetime)
              vm.createLocalCampaign(campaignData)

              if (n === 7) {
                vm.hideLoading()
                setTimeout(function () {
                  vm.getLocalCampaigns()
                }, 1000)
              }
            }
         });
      },
      createSegment3MailchimpCampaign: function (grapeIDs, datetime) {
        let vm = this
        const req = Request        
        .post('https://us-central1-grapevine-dc853.cloudfunctions.net/MailchimpCreateCampaign')
        .query({ list_id: vm.mailchimpListID })
        .query({ title: vm.mailchimpListName + ': ' + vm.grapeListName + ': 7 a week' })
        .query({ subject: 'Your weekly email from Grapevine' })
        .query({ segment_id: vm.segment7aweek })
        .then(function(res) {
            var data = JSON.parse(res.body.text)
            console.log(data)
            if (data.id) {
              let campaignData = {
                grapeListID : vm.grapeListID,
                grapeListName : vm.grapeListName,
                mailchimpListID : vm.mailchimpListID,
                mailchimpListName : vm.mailchimpListName,
                mailchimpCampaignID : data.id,
                mailchimpCampaignSubject : data.settings.title,
                mailchimpCampaignStatus : data.status,
                creationScheduledTime: datetime 
              }
              vm.setCampaignContent(data.id, grapeIDs, datetime)
              vm.createLocalCampaign(campaignData)
            }
         });
      },
      createCampaignContent: function (campaignID, grapeIDs, datetime) {
        let vm = this
        var content = ''

        var grapesProcessed = 0
        console.log(grapeIDs)
        grapeIDs.forEach(grapeID => {
          db.collection('grapes').where('id', '==', grapeID).get().then((querySnapshot) => {
            querySnapshot.forEach((doc) => {
              var grapeData = doc.data()
              // grape
              var wordcount = 0
              var regex = /\s+/gi
              wordcount = grapeData.grapeContent.trim().replace(regex, ' ').split(' ').length
              content += '<div class="content-wrap" style="text-align: left; padding: 0 50px; margin-bottom: 30px; font-family: \'PT Sans\', open sans, Helvetica, sans-serif;">'
              content += '<div style="text-align: left; width: 100%; border-bottom: 1px solid #eaeaea;padding-bottom: 2px;font-size: 1em;margin-bottom: 10px;"><span style="color: #43B73B;">@' + grapeData.grapeUsername + '</span><span style="float: right;">' + wordcount + ' words</span></div>'            
              content += '<img src="' + grapeData.sourceImage + '" style="float: left; margin: 40px 40px 50px 0;"/>'
              content += '<h4 class="grape-author" style="font-size: 1.8em;text-transform: uppercase;font-weight: 700;color: #43B73B;margin: 20px 0 10px;padding-top: 45px;">' + grapeData.sourceAuthor + '</h4>'
              content += '<h3 style="margin-top: .8em;font-size: 1.35em;padding-bottom: 7.5px;">' + grapeData.grapeTitle + '</h3>'
              content += '<hr style="width: 30%;margin: 0;border: 0; border-top: 1px solid #eaeaea;" />'
              content += '<h5 style="font-size: 1.1em; font-weight: normal; font-style: italic;">' + grapeData.grapeSource + ' <span style="font-style: normal;">(' + grapeData.grapeOriginalPublishYear + ')</span></h5>'
              grapeData.grapeContent = grapeData.grapeContent.replace(/\<p/g, '<p style="margin: 0;"')
              content += '<div style="clear: both; line-height: 1.6em;font-size: 1.2em;">' + grapeData.grapeContent + '</div>'
              content += '</div>'

              grapesProcessed++
              if (grapesProcessed === grapeIDs.length) {  
                vm.setCampaignContent(campaignID, content, datetime)
              }
            })
          })
        })
      },
      setCampaignContent: function (campaignID, grapeIDs, datetime) {
        let vm = this
        const req = Request
        .post('https://us-central1-grapevine-dc853.cloudfunctions.net/MailchimpSetCampaignContent')
        .query({ campaignID: campaignID })
        .query({ grapeIDs: grapeIDs })
        .then(function(res) {
            var data = JSON.parse(res.body.text)
            console.log(data);
            vm.scheduleCampaign(campaignID, datetime)
        });
      },
      createLocalCampaign: function (campaignData) {
        let vm = this
        vm.isAddingCampaign = true
        campaignData.createdTimestamp = firebase.firestore.FieldValue.serverTimestamp()
        db.collection('mailchimpCampaigns').add(campaignData).then(function (docRef) {
          console.log('Document written with ID: ', docRef.id)
          setTimeout(function () {
            vm.isAddingCampaign = false
          }, 500)
        })
      },
      getCampaignDetails: function (campaignData) {
        let vm = this
        const req = Request
        .get('https://us-central1-grapevine-dc853.cloudfunctions.net/MailchimpGetCampaignDetails')
        .query({ campaignID: campaignData.mailchimpCampaignID })
        .then(function(res) {
          var data = JSON.parse(res.body.text)
          console.log(data)
          if (data.status != '404') {
            campaignData.mailchimpCampaignStatus = data.status
          } else {
            campaignData.mailchimpCampaignStatus = 'not found'
            return
          }
          if (data.send_time) {
            campaignData.mailchimpCampaignSendTime = data.send_time
          }
          vm.localCampaigns.push(campaignData)
          vm.campaignsSort()
        })
      },
      scheduleCampaign: function (campaignID, datetime) {
        let vm = this
        datetime = datetime.slice(0, -7) + '00+00:00'
        vm.setCampaignSchedule(campaignID, datetime)
      },
      setCampaignSchedule: function (campaignID, datetime) {
        console.log('campaignID: ' + campaignID + ', datetime: ' + datetime)
        const req = Request        
        .post('https://us-central1-grapevine-dc853.cloudfunctions.net/MailchimpSetCampaignSchedule')
        .query({ campaignID: campaignID })
        .query({ scheduleTime: datetime }) // Must look like this format: 2019-02-04T19:15:00+00:00
        .then(function(res) {
            var text = res.body.text
            if (text === '') {

            } else {
              var data = JSON.parse(res.body.text)
              if (data.status == 400) {
                alert(data.detail)
              }
            }
         });
      },
      getLists: function () {
        let vm = this
        var listsRef = db.collection('lists')
        listsRef.get().then((querySnapshot) => {
          console.log('created query: ' + querySnapshot.docs.length)
          querySnapshot.forEach((doc) => {
            var listData = doc.data()
            listData.id = doc.id
            if (!vm.checkPresentInArray(vm.lists, listData.id, true)) {          
              vm.lists.push(listData)
            }
          })
          setTimeout(function () {
            vm.hideLoading()
            vm.listChange()
          }, 1000)
        })
      },
      listChange: function () {
        let vm = this
        let $listID = $('#list_select').val()
        console.log('list changed: ' + $listID)
        vm.listGrapeIDs = []
        var listRef = db.collection('lists').doc($listID)
        listRef.get().then(function (doc) {
          console.log(doc.id, ' => ', doc.data())
          vm.listGrapeIDs = doc.data().grapes
        })
      },
      getLocalCampaigns: function () {
        let vm = this
        var campaignsRef = db.collection('mailchimpCampaigns')
        campaignsRef.get().then((querySnapshot) => {
          console.log('created query: ' + querySnapshot.docs.length)
          querySnapshot.forEach((doc) => {
            var campaignData = doc.data()
            campaignData.id = doc.id
            if (!vm.checkPresentInArray(vm.localCampaigns, campaignData.id, true)) {
              vm.getCampaignDetails(campaignData)
            }
          })
          setTimeout(function () {
            vm.hideLoading()
          }, 1000)
        })
      },
      campaignsSort: function () {
        let vm = this
        vm.localCampaigns.sort(function (a, b) {
          var textA = a.mailchimpCampaignSubject.toUpperCase()
          var textB = b.mailchimpCampaignSubject.toUpperCase()
          return (textA < textB) ? -1 : (textA > textB) ? 1 : 0
        })
      },
      checkPresentInArray: function (inArr, ID, exists) {
        for (var i = 0; i < inArr.length; i++) {
          if (inArr[i].id === ID) {
            return (exists === true) ? true : inArr[i]
          }
        }
      }
    },
    mounted () {
    }
  };
</script>

<style>
  .theme-grapevine .vdatetime-popup__header,
  .theme-grapevine .vdatetime-calendar__month__day--selected > span > span,
  .theme-grapevine .vdatetime-calendar__month__day--selected:hover > span > span {
    background: #36a731;
  }

  .theme-grapevine .vdatetime-year-picker__item--selected,
  .theme-grapevine .vdatetime-time-picker__item--selected,
  .theme-grapevine .vdatetime-popup__actions__button {
    color: #36a731;
  }
  .input-field {
    position: relative;
    margin-bottom: 20px;
  }
  .list-wrap {
    text-align: left;
    max-width: 90%;
    margin: 0 auto 100px;
  }
  .list-wrap .pure-form {
    margin-bottom: 30px;
    padding-bottom: 20px;
    border-bottom: 1px solid #ececec;
  }
  .list-wrap .pure-form label {
    font-weight: bold;
    line-height: 30px
  }
  .list-wrap .pure-form select, .list-wrap .pure-form input {
    width: 100%;
  }
  .list-wrap .pure-form .vdatetime-input {
    width: 250px;
  }
  .list-wrap form input[type="search"] {
    line-height: 30px;
    width: 100%;
    margin-bottom: 10px;
    box-sizing: border-box;
  }
  .list-actions {
    padding-right: 20px;
    box-sizing: border-box;
  }
  .list-actions h4 {
    border-bottom: 1px solid #2c3e50;
    padding: 0 0 4px;
    margin: 30px 0 20px;
    line-height: 30px;
  }
</style>


// WEBPACK FOOTER //
// src/components/admin/mailchimpAdmin.vue